<app-navbar></app-navbar>
<div class="container-fluid main bg">
  <br><br><br>
  <router-outlet></router-outlet>
</div>
<ng-http-loader></ng-http-loader>


